import { useDispatch, useSelector } from "react-redux";
import { setKeyValue } from "../../../../store/chats/slice";
import Avatar from "../../../../components/generic/Avatar";
import { convertDateToFromNow } from "../../../../utils/dayjs";
import { renderContentWithLinks } from "../ChatWindow/MessageItem/LinkUtils";
import { Tag } from "antd";
import { getStatusColor } from "../ChatWindow/helper";
import { getFullName } from "../../../../utils/shared";
import { useMemo } from "react";
import { SYSTEM_SENDER } from "../../../../constant";
import { selectUser } from "../../../../store/user/selectors";
import { TeamOutlined } from "@ant-design/icons";

const SENDER_RESOLVERS = {
  system: () => SYSTEM_SENDER,
  user: (chat, senderId) => chat.members?.find((m) => m.id === senderId),
  customer: (chat, senderId) => chat.customers?.find((c) => c.id === senderId),
};

const ConvListItem = ({ selectedChatId, chat }) => {
  const dispatch = useDispatch();

  const user = useSelector(selectUser);

  const lastMessageUserName = useMemo(() => {
    const { sender_type, sender_id } = chat?.last_message || {};

    const resolver = SENDER_RESOLVERS[sender_type];

    return getFullName(resolver ? resolver(chat, sender_id) : chat.customer);
  }, [chat]);

  const { avatarUser, chatTitle } = useMemo(() => {
    let avatarUser = null;

    if (chat?.customer) {
      avatarUser = chat.customer;
    } else if (chat?.members?.length === 2) {
      avatarUser = chat.members.find(({ id }) => user?.user_id !== id);
    }

    const chatTitle =
      chat?.name ||
      (chat?.branch ? `📍 ${chat.branch.name || ""}` : null) ||
      (avatarUser
        ? getFullName(avatarUser)
        : chat?.members
            ?.filter(({ id }) => id !== user?.user_id)
            ?.map(({ first_name, last_name }) =>
              `${first_name || ""} ${last_name?.[0] || ""}`.trim(),
            )
            ?.join(", ") || "");

    return { avatarUser, chatTitle };
  }, [chat, user?.user_id]);

  return (
    <div
      key={chat.id}
      className={`conversation-card ${chat?.customer ? "external" : "internal"} ${
        selectedChatId === chat?.id ? "selected" : ""
      }`}
      onClick={() =>
        dispatch(
          setKeyValue({
            key: "selectedChatId",
            value: chat?.id,
          }),
        )
      }
    >
      <div className="avatar-section">
        {avatarUser ? (
          <Avatar size={40} user={avatarUser} />
        ) : (
          <TeamOutlined className="group-icon" />
        )}
      </div>

      <div className="card-content">
        <div className="card-top">
          <div className="customer-name capitalize-text ellipsis-text ">
            #{chat.display_id}&nbsp; {chatTitle}
          </div>
          <span className="timestamp">
            {convertDateToFromNow(
              chat?.last_message?.sent_at || chat?.created_at,
            )}
          </span>
        </div>

        <div className="card-middle">
          <span className="last-message ellipsis-text">
            {renderContentWithLinks({
              text: chat?.last_message?.content,
              users: chat?.users,
              showLink: false,
            }) || "There is no message"}
          </span>

          <Tag className="capitalize-text" color={getStatusColor(chat.status)}>
            {chat.status}
          </Tag>
        </div>
        <div className="card-bottom">
          <span className="ticket-badge ellipsis-text">
            {lastMessageUserName}
          </span>
          <span className="topic-label">
            {chat.topic ? chat.topic.name : "Internal"}
          </span>
        </div>
      </div>
    </div>
  );
};
export default ConvListItem;
